import { css } from "styled-components";
import space from "../space";
var setClickableArea = function setClickableArea(sizeSpace) {
  return css(["&::after{content:\"\";position:absolute;top:50%;left:50%;min-width:", ";min-height:", ";transform:translate(-50%,-50%);opacity:0;}"], space(sizeSpace), space(sizeSpace));
};
export default setClickableArea;